"use client";

import {
  AccordionContent,
  AccordionItem,
  Root as AccordionRoot,
  AccordionTrigger,
} from "@radix-ui/react-accordion";
import { useTranslations } from "next-intl";
import { Balancer } from "react-wrap-balancer";

import { MinusIcon } from "~/components/icons/minus-icon";
import { PlusIcon } from "~/components/icons/plus-icon";
import { QuestionMarkIcon } from "~/components/icons/question-mark";
import { H3, HR } from "~/components/typography";

// Define the QA record type inline based on the GraphQL schema
interface Qa {
  id: string;
  question: string;
  answer: string;
}

export function Questions({ qas }: { qas: Qa[] }) {
  const tCommon = useTranslations("Common");

  return qas.length > 0 ? (
    <div className="bg-prune-200 text-prune-500 rounded-xl p-4 md:p-8 lg:p-12">
      <div className="md:mx-auto md:max-w-3xl">
        <div className="my-4 flex flex-col items-center gap-4 md:gap-6">
          <QuestionMarkIcon />
          <H3>
            <Balancer className="text-center">
              {tCommon("frequentlyAskedQuestions")}
            </Balancer>
          </H3>
        </div>
        <AccordionRoot type="multiple" className="mt-8 text-base">
          {qas.map((qa, index) => (
            <AccordionItem key={qa.id} value={qa.id}>
              {index !== 0 ? <HR className="my-6" /> : null}
              <AccordionTrigger className="group mb-2 flex w-full items-start justify-between gap-4 text-left font-medium">
                <div className="grow">{qa.question}</div>
                <PlusIcon className="block shrink-0 group-data-[state=open]:hidden" />
                <MinusIcon className="hidden shrink-0 group-data-[state=open]:block" />
              </AccordionTrigger>
              <AccordionContent className="text-black/90">
                {qa.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </AccordionRoot>
      </div>
    </div>
  ) : null;
}
